import React, { useEffect, useState, useCallback, useMemo } from "react";
import compose from "recompose/compose";
import { withStyles } from "@material-ui/core/styles";
import EmojiEventsTwoToneIcon from "@material-ui/icons/EmojiEventsTwoTone";
import {
  getTeamLeaderboard,
  getRunnerLeaderboard,
  getRunnerList,
  getTeamList,
  getTeamAndGroupNames,
  getFamilyGroupLeaderboard,
  getFamilyListData,
} from "../../../../../../apis/eventService";
import Autosuggest from "react-autosuggest";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Snackbar from "../../../../../common/Snackbar";

import {
  NativeSelect,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@material-ui/core";
import BoardList from "./BoardList";
import SubmitCancelBtn from "../../../../../common/SubmitCancelBtn";
import ApplicationUtil from "../../../../../../utils/ApplicationUtil";
import { withRouter } from "react-router-dom";
import Ticker from "react-ticker";
import GoldMedal from "../../../../../../images/gold-medal.png";
import SilverMedal from "../../../../../../images/silver-medal.png";
import BronzeMedal from "../../../../../../images/bronze-medal.png";
import ApplicationConstants from "../../../../../../constants/ApplicationConstants";
import Properties from "../../../../../../properties/Properties";

const styles = (theme) => ({
  leaderboard_top: {
    width: "90%",
    margin: "auto",
    [theme.breakpoints.down("sm")]: { width: "100%" },
  },
  input: {
    "& .react-autosuggest__container": { position: "relative" },
    "& .react-autosuggest__input": {
      width: "100%",
      height: "40px",
      padding: "10px 10px",
      marginTop: "10px",
      fontFamily: "Helvetica, sans-serif",
      fontWeight: 300,
      fontSize: "16px",
      border: "1px solid #aaa",
      borderRadius: "6px",
      [theme.breakpoints.down("sm")]: { width: "150%" },
    },
    "& .react-autosuggest__input--focused": { outline: "none" },
    "& .react-autosuggest__input--open": {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
    "& .react-autosuggest__suggestions-container": { display: "none" },
    "& .react-autosuggest__suggestions-container--open": {
      display: "block",
      position: "absolute",
      top: "51px",
      width: "100%",
      textAlign: "left",
      border: "1px solid #aaa",
      backgroundColor: "#fff",
      fontFamily: "Helvetica, sans-serif",
      fontWeight: 300,
      fontSize: "16px",
      borderBottomLeftRadius: "4px",
      borderBottomRightRadius: "4px",
      zIndex: 2,
      overflow: "auto",
      [theme.breakpoints.down("sm")]: {
        width: "150%",
        marginRight: "15%",
      },
    },
    "& .react-autosuggest__suggestions-list": {
      margin: 0,
      padding: 0,
      listStyleType: "none",
    },
    "& .react-autosuggest__suggestion": {
      cursor: "pointer",
      padding: "10px 20px",
    },
    "& .react-autosuggest__suggestion--highlighted": {
      backgroundColor: "#ddd",
      color: "#000",
    },
    [theme.breakpoints.down("sm")]: { marginLeft: "15%" },
  },
  container_top: { display: "flex", alignItems: "center", gap: "5px" },
  root: { width: "100%", "& h3": { fontSize: "18px" } },
  winnerTeamsContainer: {
    marginTop: "30px",
    display: "flex",
    alignItems: "flex-start",
    "& .teamLayout": {
      color: "#ffffff",
      backgroundColor: "#0077b6",
      borderRadius: "0",
    },
    "& .MuiAccordion-root.Mui-expanded": { margin: "0px" },
    "& .teamWinner1": {
      width: "100%",
      ["@media (max-width:600px)"]: { width: "89%" },
    },
    "& .teamWinner2": {
      width: "100%",
      ["@media (max-width:600px)"]: { width: "89%" },
    },
    "& .teamWinner3": {
      width: "100%",
      marginBottom: "10px",
      ["@media (max-width:600px)"]: { width: "89%" },
    },
    "& .medalIcons": {
      height: 60,
      width: 60,
      objectFit: "contain",
      ["@media (max-width:600px)"]: { height: 35, width: 35 },
    },
  },
  teamListContainer: {
    marginTop: "20px",
    "& .teamList": {
      width: "95%",
      marginLeft: "5%",
      borderRadius: "0",
      backgroundColor: "#0077b6",
      color: "#ffffff",
    },
    "& .accordion": { "& .MuiIconButton-root": { visibility: "hidden" } },
  },
  dropdownStyling: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "space-between",
      marginBottom: "20px",
    },
  },
  search__select: { display: "flex", alignItems: "flex-end" },
  winnerIconsContainer: { display: "flex", alignItems: "center" },
});

function TeamBoard(props) {
  const {
    classes,
    radioValue,
    challengeType,
    ageWiseData,
    ageWiseDataChallengeParameter,
  } = props;

  // Leaderboard state
  const [expanded, setExpanded] = useState(false);
  const [challengeParameter, setChallengeParameter] = useState("");
  const [intervalCount, setIntervalCount] = useState(0);
  const [teamTickerText, setTeamTickerText] = useState(null);

  // data containers
  const [teamWinnersData, setTeamWinnersData] = useState([]);
  const [teamData, setTeamData] = useState([]);
  const [teamListData, setTeamListData] = useState([]);
  const [runnerWinnersData, setRunnerWinnersData] = useState([]);
  const [runnersData, setRunnersData] = useState([]);
  const [runnerListData, setRunnerListData] = useState([]);

  // family group states
  const [familyWinnersData, setFamilyWinnersData] = useState([]);
  const [familyGroupData, setFamilyGroupData] = useState([]); // full data from API
  const [familyDisplayData, setFamilyDisplayData] = useState([]); // what we display (filtered & limited)
  const [familyListData, setFamilyListData] = useState([]);

  // misc
  const [value, setSearchValue] = useState("");
  const [selectedSuggestion, setSelectedSuggestion] = useState(null); // autosuggest selection
  const [totalRunners, setTotalRunner] = useState(null);
  // const [teamNames, setTeamNames] = useState(null);
  const [totalTeams, setTotalTeam] = useState(null);
  const [teamNames, setTeamNames] = useState([]);
  const [runnerGroupNames, setRunnerGroupNames] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [limitRows, setLimitRows] = useState(
    ApplicationConstants.limitRowsArrayTeamAndIndividual?.[0]?.value,
  );
  const [isExpandedTeam, setIsExpandedTeam] = useState({});

  // helper to split winners/rest
  const splitWinners = (items = [], rankKey = "teamRank") => {
    const winners = items.filter((x) => [1, 2, 3].includes(Number(x[rankKey])));
    const rest = items.filter((x) => Number(x[rankKey]) > 3);
    return { winners, rest };
  };

  // initial + periodic load
  const initialDataLoad = useCallback(async () => {
    const runnerEventId = ApplicationUtil.getRunnersEventID();
    const organizerEventId = ApplicationUtil.getSupportsEventID();
    const eventId = window.location.href.includes("/organizer")
      ? organizerEventId
      : runnerEventId;

    try {
      if (radioValue === "team" || radioValue === "individual") {
        const { data } = await getTeamLeaderboard(eventId, limitRows);
        if (data) {
          const { winners, rest } = splitWinners(
            data?.teamDetails || [],
            "teamRank",
          );
          const teamNamesResp = await getTeamAndGroupNames(eventId, "TEAMS");
          setTeamNames(teamNamesResp?.data?.teamDetails || []);
          setTeamWinnersData(winners || []);
          setTeamData(rest || []);
          setTotalTeam(data);
          setTeamTickerText(data.teamTickerText);
          setChallengeParameter(data?.challengeParameter);
        }
      }

      if (radioValue === "runnerGroup") {
        const { data } = await getRunnerLeaderboard(eventId);
        if (data) {
          const { winners, rest } = splitWinners(
            data?.runnerGroupDetailsDTO || [],
            "runnerGroupRank",
          );
          const runnerNamesResp = await getTeamAndGroupNames(
            eventId,
            "RUNNER_GROUPS",
          );
          setRunnerGroupNames(
            runnerNamesResp?.data?.runnerGroupDetailsDTO || [],
          );
          setRunnerWinnersData(winners || []);
          setRunnersData(rest || []);
          setTotalRunner(data);
          setChallengeParameter(data?.challengeParameter);
        }
      }

      if (radioValue === "showFamilyGroup") {
        const { data } = await getFamilyGroupLeaderboard(eventId, limitRows);
        if (data) {
          // data is assumed ordered (best first)
          const winners = data.slice(0, 3);
          const rest = data.slice(3);
          setFamilyGroupData(data || []);
          setFamilyWinnersData(winners || []);
          // apply limitRows to what is displayed in family tab
          setFamilyDisplayData((rest || []).slice(0, limitRows));
          setChallengeParameter(data?.challengeParameter || "");
        }
      }
    } catch (e) {
      console.error(e);
    }
  }, [radioValue, limitRows]);

  // run on mount and set up periodic refresh (only after first run)
  useEffect(() => {
    if (intervalCount > 0) {
      const boardInterval = setInterval(() => {
        initialDataLoad();
      }, 2000000);
      return () => clearInterval(boardInterval);
    } else {
      initialDataLoad();
      setIntervalCount(1);
    }
  }, [intervalCount, initialDataLoad]);

  // reload when limitRows changes (skip initial mount handled above)
  useEffect(() => {
    initialDataLoad();
    setSearchValue("");
    setSelectedSuggestion(null);
  }, [limitRows, initialDataLoad]);

  const onLimitChange = (event) => {
    const newLimit = parseInt(event?.target?.value);
    setLimitRows(newLimit);
    // if family tab currently showing search results, reapply limit (case-insensitive)
    if (radioValue === "showFamilyGroup") {
      if (value) {
        const filtered = (familyGroupData || []).filter((item) =>
          (item?.groupName || "")
            .toLowerCase()
            .includes((value || "").toLowerCase()),
        );
        setFamilyDisplayData(filtered.slice(0, newLimit));
      } else {
        const rest = (familyGroupData || []).slice(3);
        setFamilyDisplayData(rest.slice(0, newLimit));
      }
    }
  };

  // Accordion expand handler: fetch list for the opened item
  const handleChange = (panel) => async (event, isExpanded) => {
    event.preventDefault();
    event.stopPropagation();

    if (!isExpanded) {
      setExpanded(false);
      return;
    }

    const runnerEventId = ApplicationUtil.getRunnersEventID();
    const organizerEventId = ApplicationUtil.getSupportsEventID();
    const eventId = window.location.href.includes("/organizer")
      ? organizerEventId
      : runnerEventId;

    try {
      if (radioValue === "runnerGroup") {
        const { data } = await getRunnerList({ eventId, runnerGroupId: panel });
        setRunnerListData(data?.particiapants?.[0]?.runnerActivities || []);
      } else if (radioValue === "team" || radioValue === "individual") {
        const { data } = await getTeamList({ eventId, teamId: panel });
        if (data) {
          setIsExpandedTeam(data);
          setTeamListData(data?.teamMemberActivities || []);
        }
      } else if (radioValue === "showFamilyGroup") {
        const { data } = await getFamilyListData({ eventId, teamId: panel });
        if (data) {
          setIsExpandedTeam(data);
          setFamilyListData(data || []);
        }
      }
    } catch (e) {
      console.error(e);
    }

    setExpanded(panel ? (isExpanded ? panel : false) : false);
  };

  const editTeamMember = (teamMember = [], param) => {
    return (teamMember || []).filter((x) =>
      param === "STEPS"
        ? x.totalSteps > 0
        : param === "WELLNESS_POINT"
          ? x.totalWellnessPoint > 0
          : x.totalActivityDistance > 0,
    );
  };

  const getTitle = () => {
    if (
      ApplicationConstants.isProd &&
      ApplicationConstants?.challengeLabel_Location_Prod?.includes(
        challengeType?.id,
      )
    ) {
      return "Cohort Wise Leaderboard";
    }
    if ([2592, 678, 507, 508, 515].includes(challengeType?.id)) {
      return "Corporate Groups";
    }
    if (challengeType?.id === 2473) return "Cohort Wise Leaderboard";
    if (radioValue === Properties?.ageWiseGroupRadioValue)
      return "Age Wise Leaderboard";
    if (ApplicationUtil.isCohortBasedEventId(challengeType?.id))
      return "Cohort Based Leaderboard";
    if (radioValue === "runnerGroup") return "Runner Group Leaderboard";
    if (radioValue === "showFamilyGroup") return "Family Group Leaderboard";
    return "Team Leaderboard";
  };

  const getSuggestions = useCallback(
    (input) => {
      const inputValue = (input || "").trim().toLowerCase();
      if (!inputValue) return [];
      if (radioValue === "runnerGroup") {
        return (runnerGroupNames || []).filter((g) =>
          g?.runnerGroupName?.toLowerCase().includes(inputValue),
        );
      }
      if (radioValue === "team") {
        return (teamNames || []).filter((t) =>
          t?.teamName?.toLowerCase().includes(inputValue),
        );
      }
      if (radioValue === "showFamilyGroup") {
        return (familyGroupData || []).filter((f) =>
          f?.groupName?.toLowerCase().includes(inputValue),
        );
      }
      return [];
    },
    [radioValue, runnerGroupNames, teamNames, familyGroupData],
  );

  const onSuggestionsFetchRequested = ({ value }) => {
    setSuggestions(getSuggestions(value));
    setSelectedSuggestion(null);
  };
  const onSuggestionsClearRequested = () => setSuggestions([]);

  const getSuggestionValue = (suggestion) =>
    radioValue === "team"
      ? suggestion?.teamName
      : radioValue === "runnerGroup"
        ? suggestion?.runnerGroupName
        : radioValue === "showFamilyGroup"
          ? suggestion?.groupName
          : "";

  const renderSuggestion = (suggestion) => (
    <div style={{ padding: 8 }}>{getSuggestionValue(suggestion)}</div>
  );

  // when a suggestion is selected, set value + remember selection
  const onSuggestionSelected = (event, { suggestion, method }) => {
    // prevent submit on enter
    if (method === "enter") event.preventDefault();
    const suggestionVal = getSuggestionValue(suggestion);
    setSearchValue(suggestionVal);
    setSelectedSuggestion(suggestion);
    setSuggestions([]);
  };

  // search input change
  const searchHandleChange = (event, { newValue }) => {
    setSearchValue(newValue);
    // if user types after selecting suggestion, clear selection
    if (
      selectedSuggestion &&
      getSuggestionValue(selectedSuggestion) !== newValue
    ) {
      setSelectedSuggestion(null);
    }
    if (newValue === "") {
      // reset to original datasets
      if (radioValue === "runnerGroup") {
        const winners = totalRunners?.runnerGroupDetailsDTO?.filter((x) =>
          [1, 2, 3].includes(Number(x.runnerGroupRank)),
        );
        const rest = totalRunners?.runnerGroupDetailsDTO?.filter(
          (x) => Number(x.runnerGroupRank) > 3,
        );
        setRunnerWinnersData(winners || []);
        setRunnersData(rest || []);
      } else if (radioValue === "team") {
        const winners = totalTeams?.teamDetails?.filter((x) =>
          [1, 2, 3].includes(Number(x.teamRank)),
        );
        const rest = totalTeams?.teamDetails?.filter(
          (x) => Number(x.teamRank) > 3,
        );
        setTeamWinnersData(winners || []);
        setTeamData(rest || []);
      } else if (radioValue === "showFamilyGroup") {
        // show rest of family groups (apply limit)
        const rest = (familyGroupData || []).slice(3);
        setFamilyWinnersData((familyGroupData || []).slice(0, 3));
        setFamilyDisplayData(rest.slice(0, limitRows));
      }
    }
  };

  // search button click
  const searchHandleClick = (search) => {
    if (!value) {
      Snackbar.show({
        variant: "error",
        isAutoHide: true,
        preventDuplicate: true,
        message:
          radioValue === "showFamilyGroup"
            ? "Please enter family group name"
            : radioValue === "runnerGroup"
              ? "Please enter runner group name"
              : "Please enter team name",
      });
      return;
    }

    const normalized = (value || "").toLowerCase();

    if (radioValue === "runnerGroup") {
      const results = (runnerGroupNames || []).filter((item) =>
        (item?.runnerGroupName || "").toLowerCase().includes(normalized),
      );
      if (results?.length) {
        const winners = results.filter((r) => Number(r.runnerGroupRank) <= 3);
        const rest = results.filter((r) => Number(r.runnerGroupRank) > 3);
        setRunnerWinnersData(winners || []);
        setRunnersData(rest || []);
      } else {
        setRunnerWinnersData([]);
        setRunnersData([]);
      }
    } else if (radioValue === "team") {
      const results = (teamNames || []).filter((item) =>
        (item?.teamName || "").toLowerCase().includes(normalized),
      );
      if (results?.length) {
        const winners = results.filter((t) => Number(t.teamRank) <= 3);
        const rest = results.filter((t) => Number(t.teamRank) > 3);
        setTeamWinnersData(winners || []);
        setTeamData(rest || []);
      } else {
        setTeamWinnersData([]);
        setTeamData([]);
      }
    } else if (radioValue === "showFamilyGroup") {
      // If user selected a suggestion and it matches the value exactly, show only that group
      if (
        selectedSuggestion &&
        getSuggestionValue(selectedSuggestion) === value
      ) {
        const s = selectedSuggestion;
        if (Number(s.groupRank) <= 3) {
          setFamilyWinnersData([s]);
          setFamilyDisplayData([]);
        } else {
          setFamilyWinnersData([]);
          setFamilyDisplayData([s].slice(0, limitRows));
        }
        return;
      }

      // otherwise filter the full familyGroupData (case-insensitive) and apply limitRows
      const results = (familyGroupData || []).filter((item) =>
        (item?.groupName || "").toLowerCase().includes(normalized),
      );
      if (results?.length) {
        // split into winners/rest by groupRank if rank present, else assume top 3 winners come from original winners
        const winners = results.filter((r) => Number(r.groupRank) <= 3);
        const rest = results.filter((r) => Number(r.groupRank) > 3);
        if (winners.length > 0 || rest.length > 0) {
          setFamilyWinnersData(winners || []);
          setFamilyDisplayData(rest.slice(0, limitRows) || []);
        } else {
          // fallback: if result objects don't have groupRank, show matched items as display
          setFamilyWinnersData([]);
          setFamilyDisplayData(results.slice(0, limitRows));
        }
      } else {
        setFamilyWinnersData([]);
        setFamilyDisplayData([]);
      }
    }
  };

  const hasAnyData = useMemo(
    () =>
      teamWinnersData?.length > 0 ||
      runnerWinnersData?.length > 0 ||
      teamData?.length > 0 ||
      runnersData?.length > 0 ||
      familyDisplayData?.length > 0 ||
      ageWiseData?.length > 0,
    [
      teamWinnersData,
      runnerWinnersData,
      teamData,
      runnersData,
      familyDisplayData,
      ageWiseData,
    ],
  );

  const AccordionSummaryData = ({ value, align }) => (
    <Grid
      item
      style={{
        textAlign: align || "left",
        fontSize: window.innerWidth >= 600 ? "18px" : "16px",
      }}
    >
      <span style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }}>
        {value}{" "}
      </span>
    </Grid>
  );

  const AccordionSummaryContainer = ({
    team,
    runner,
    AgeItem,
    ageIndex,
    radio,
    index,
  }) => {
    const rp = radio || radioValue;
    return (
      <AccordionSummary
        onMouseDown={(e) => e.preventDefault()}
        expandIcon={<ExpandMoreIcon style={{ color: "#ffffff" }} />}
      >
        {rp === "showFamilyGroup" ? (
          <Grid container>
            <Grid item xs={6}>
              <AccordionSummaryData value={runner?.groupName} />
            </Grid>
            <Grid item xs={3}>
              <AccordionSummaryData
                value={
                  ApplicationUtil.formatNumberWithCommas(
                    parseFloat((runner?.totalDistance || 0) / 1000).toFixed(2),
                  ) + " Km"
                }
                align={"center"}
              />
            </Grid>
            <Grid item xs={3}>
              {/* <Grid item xs={3}><AccordionSummaryData value={ApplicationUtil.formatNumberWithCommas(index+1)} align={"right"} /></Grid> */}
            </Grid>
          </Grid>
        ) : rp === "team" || rp === "individual" ? (
          <Grid container>
            <Grid item xs={6}>
              <AccordionSummaryData
                value={
                  <>
                    {/* As per research unity among 50 teams one of the corporate event 'wellness voyage 3.0' conducted by ND studios, we found that teams with a unity index above 0.2 performed better in the leaderboard, indicating a positive correlation between team unity and performance in the challenge. */}
                    {ApplicationUtil.formatNumberWithCommas(team?.teamRank)}
                    {". "}
                    {team?.teamName}
                    {team?.unityIndex !== undefined &&
                      team?.unityIndex !== null && (
                        <span style={{ marginLeft: "8px" }}>
                          {team.unityIndex > 0.25 ? "😊" : ""}
                        </span>
                      )}
                  </>
                }
              />
            </Grid>
            {challengeParameter === "DISTANCE" && (
              <Grid
                item
                xs={3}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <Grid
                  style={{
                    textAlign: "center",
                    fontSize: "small",
                  }}
                >
                  Achieved
                </Grid>
                <Grid>
                  <AccordionSummaryData
                    value={
                      ApplicationUtil.formatNumberWithCommas(
                        parseFloat((team?.teamDistance || 0) / 1000).toFixed(2),
                      ) + " Km"
                    }
                    align={"center"}
                  />
                </Grid>
              </Grid>
            )}
            {challengeParameter === "CALORIE" && (
              <Grid item xs={3}>
                <AccordionSummaryData
                  value={ApplicationUtil.formatNumberWithCommas(
                    team?.teamTotalCalories,
                  )}
                  align={"center"}
                />
              </Grid>
            )}
            {challengeParameter === "STEPS" && (
              <Grid
                item
                xs={3}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <Grid
                  style={{
                    textAlign: "center",
                    fontSize: "small",
                  }}
                >
                  Achieved
                </Grid>
                <Grid>
                  <AccordionSummaryData
                    value={ApplicationUtil.formatNumberWithCommas(
                      team?.teamTotalSteps,
                    )}
                    align={"center"}
                  />
                </Grid>
              </Grid>
            )}
            {challengeParameter === "ELEVATION" && (
              <Grid item xs={3}>
                <AccordionSummaryData
                  value={ApplicationUtil.formatNumberWithCommas(
                    team?.teamTotalElevationGain,
                  )}
                  align={"center"}
                />
              </Grid>
            )}
            {challengeParameter === "WELLNESS_POINT" && (
              <Grid item xs={3}>
                <AccordionSummaryData
                  value={ApplicationUtil.formatNumberWithCommas(
                    team?.teamTotalWellnessPoint,
                  )}
                  align={"center"}
                />
              </Grid>
            )}
            {!ApplicationUtil.hideMedal_Rank(challengeType?.id) && team?.teamTarget !== undefined && team?.teamTarget !== null && Number(team?.teamTarget) > 0 && (
              <Grid
                item
                xs={3}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <Grid
                  style={{
                    textAlign: "center",
                    // textAlign: window.innerWidth >= 600 ? "center" : "right",
                    fontSize: "small",
                  }}
                >
                  Target
                </Grid>
                <Grid>
                  <AccordionSummaryData
                    value={
                      !team?.teamTarget
                        ? "--"
                        : challengeParameter === "DISTANCE"
                          ? ApplicationUtil.formatNumberWithCommas(
                              (team.teamTarget / 1000).toFixed(2),
                            ) + " Km"
                          : ApplicationUtil.formatNumberWithCommas(
                              team.teamTarget,
                            )
                    }
                    align={window.innerWidth >= 600 ? "center" : "right"}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        ) : rp === Properties?.ageWiseGroupRadioValue ? (
          <Grid container>
            <Grid item xs={12}>
              <AccordionSummaryData value={`Age Group ${AgeItem?.groupName}`} />
            </Grid>
          </Grid>
        ) : (
          // runnerGroup
          <Grid container>
            <Grid item xs={6}>
              <AccordionSummaryData value={runner?.runnerGroupName} />
            </Grid>
            {challengeParameter === "DISTANCE" && (
              <Grid item xs={3}>
                <AccordionSummaryData
                  value={
                    ApplicationUtil.formatNumberWithCommas(
                      parseFloat(
                        (runner?.runnerGroupDistance || 0) / 1000,
                      ).toFixed(2),
                    ) + " Km"
                  }
                  align={"center"}
                />
              </Grid>
            )}
            {challengeParameter === "CALORIE" && (
              <Grid item xs={3}>
                <AccordionSummaryData
                  value={ApplicationUtil.formatNumberWithCommas(
                    runner?.runnerGroupTotalCalories,
                  )}
                  align={"center"}
                />
              </Grid>
            )}
            {challengeParameter === "STEPS" && (
              <Grid item xs={3}>
                <AccordionSummaryData
                  value={ApplicationUtil.formatNumberWithCommas(
                    runner?.runnerGroupTotalSteps,
                  )}
                  align={"center"}
                />
              </Grid>
            )}
            {challengeParameter === "ELEVATION" && (
              <Grid item xs={3}>
                <AccordionSummaryData
                  value={ApplicationUtil.formatNumberWithCommas(
                    runner?.runnerGroupTotalElevationGain,
                  )}
                  align={"center"}
                />
              </Grid>
            )}
            {challengeParameter === "WELLNESS_POINT" && (
              <Grid item xs={3}>
                <AccordionSummaryData
                  value={ApplicationUtil.formatNumberWithCommas(
                    runner?.runnerGroupTotalWellnessPoint,
                  )}
                  align={"center"}
                />
              </Grid>
            )}
            <Grid item xs={3}>
              <AccordionSummaryData
                value={ApplicationUtil.formatNumberWithCommas(
                  runner?.runnerGroupRank,
                )}
                align={"right"}
              />
            </Grid>
          </Grid>
        )}
      </AccordionSummary>
    );
  };

  return (
    <div className={classes.leaderboard_top}>
      {radioValue !== Properties?.ageWiseGroupRadioValue && (
        <Grid
          spacing={1}
          container
          className={classes.dropdownStyling}
          style={{ marginTop: radioValue === "team" ? "20px" : 0 }}
        >
          <Grid
            item
            xs={4}
            md={2}
            style={{ textAlign: "center" }}
            className={classes.input}
          >
            <Autosuggest
              inputProps={{
                placeholder: "Search...",
                value: value,
                type: "search",
                onChange: searchHandleChange,
              }}
              suggestions={suggestions || []}
              onSuggestionsFetchRequested={onSuggestionsFetchRequested}
              onSuggestionsClearRequested={onSuggestionsClearRequested}
              onSuggestionSelected={onSuggestionSelected}
              getSuggestionValue={getSuggestionValue}
              renderSuggestion={renderSuggestion}
            />
          </Grid>

          <Grid item xs={4} md={2} style={{ textAlign: "center" }}>
            <SubmitCancelBtn
              type="submit"
              label={"Search"}
              onClick={() => searchHandleClick(value)}
              style={{ width: "60%", margin: "auto", marginTop: "10px" }}
            />
          </Grid>

          {(radioValue === "team" || radioValue === "showFamilyGroup") && (
            <Grid
              item
              xs={12}
              style={{
                padding: "15px 30px 0 0",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-start",
              }}
            >
              <div>
                <label
                  htmlFor=""
                  style={{ color: "#727272", padding: "0 5px" }}
                >
                  Top Teams
                </label>
                <NativeSelect
                  id="myDropdown"
                  style={{ width: "60px", padding: "0 5px" }}
                  onChange={onLimitChange}
                  value={limitRows}
                >
                  {ApplicationConstants.limitRowsArrayTeamAndIndividual?.map(
                    (v, i) => (
                      <option value={v.value} key={i}>
                        {v.label}
                      </option>
                    ),
                  )}
                </NativeSelect>
              </div>
            </Grid>
          )}
        </Grid>
      )}

       {/* {teamTickerText && (
        <Ticker>
          {() => (
            <p
              style={{
                fontSize: "25px",
                fontWeight: 600,
                marginLeft: "75px",
                whiteSpace: "nowrap",
                color: "#780000",
              }}
            >
              {teamTickerText + "."}
            </p>
          )}
        </Ticker>
      )}  */}

      <div
        className={classes.container_top}
        style={{
          marginTop:
            radioValue === Properties?.ageWiseGroupRadioValue ? "20px" : "",
        }}
      >
        <EmojiEventsTwoToneIcon style={{ color: "#F79824" }} />
        <span style={{ color: "rgb(40, 131, 181)", fontSize: "20px" }}>
          {getTitle()}
        </span>
      </div>

      <div className={classes.root}>
        {/* Winners - Team */}
        {teamWinnersData?.length > 0 && radioValue === "team"
          ? teamWinnersData.map((team) => (
              <div
                key={team?.teamRank}
                className={classes.winnerTeamsContainer}
              >
                {!ApplicationUtil.hideMedal_Rank(challengeType?.id) && (
                  <div className={classes.winnerIconsContainer}>
                    <img
                      src={
                        team?.teamRank === 1
                          ? GoldMedal
                          : team?.teamRank === 2
                            ? SilverMedal
                            : BronzeMedal
                      }
                      alt="medal"
                      className="medalIcons"
                    />
                  </div>
                )}
                <Accordion
                  className={`teamLayout teamWinner${team?.teamRank}`}
                  style={{
                    marginBottom:
                      ApplicationUtil.hideMedal_Rank(challengeType?.id) && 0,
                    width:
                      ApplicationUtil.hideMedal_Rank(challengeType?.id) &&
                      "100%",
                  }}
                  expanded={expanded === team?.id}
                  onChange={handleChange(team?.id)}
                >
                  <AccordionSummaryContainer
                    team={team}
                    challengeParameter={challengeParameter}
                    radio="team"
                  />
                  <AccordionDetails>
                    {teamListData?.length > 0 && (
                      <BoardList
                        challengeParameter={challengeParameter}
                        distance={challengeParameter === "DISTANCE"}
                        time={challengeParameter === "DISTANCE"}
                        sort
                        data={editTeamMember(teamListData, challengeParameter)}
                        teamLeaderId={isExpandedTeam?.teamLeaderId}
                      />
                    )}
                  </AccordionDetails>
                </Accordion>
              </div>
            ))
          : runnerWinnersData?.length > 0 && radioValue === "runnerGroup"
            ? // Winners - Runner Groups
              runnerWinnersData.map((runner) => (
                <div
                  key={runner?.runnerGroupId}
                  className={classes.winnerTeamsContainer}
                >
                  <div className={classes.winnerIconsContainer}>
                    <img
                      src={
                        runner?.runnerGroupRank === 1
                          ? GoldMedal
                          : runner?.runnerGroupRank === 2
                            ? SilverMedal
                            : BronzeMedal
                      }
                      alt="medal"
                      className="medalIcons"
                    />
                  </div>
                  <Accordion
                    className={`teamLayout teamWinner${runner?.runnerGroupRank}`}
                    style={{
                      marginBottom:
                        ApplicationUtil.hideMedal_Rank(challengeType?.id) && 0,
                      width:
                        ApplicationUtil.hideMedal_Rank(challengeType?.id) &&
                        "100%",
                    }}
                    expanded={expanded === runner?.runnerGroupId}
                    onChange={handleChange(runner?.runnerGroupId)}
                  >
                    <AccordionSummaryContainer
                      runner={runner}
                      challengeParameter={challengeParameter}
                      radio="runnerGroup"
                    />
                    <AccordionDetails>
                      {runnerListData?.length > 0 && (
                        <BoardList
                          challengeParameter={challengeParameter}
                          distance={challengeParameter === "DISTANCE"}
                          time={challengeParameter === "DISTANCE"}
                          sort
                          data={editTeamMember(
                            runnerListData,
                            challengeParameter,
                          )}
                          teamLeaderId={runner?.runnerGroupId}
                        />
                      )}
                    </AccordionDetails>
                  </Accordion>
                </div>
              ))
            : radioValue === "showFamilyGroup"
              ? familyWinnersData?.map((family, index) => (
                  <div key={family.id} className={classes.winnerTeamsContainer}>
                    <div className={classes.winnerIconsContainer}>
                      <img
                        src={
                          index === 0
                            ? GoldMedal
                            : index === 1
                              ? SilverMedal
                              : BronzeMedal
                        }
                        alt="medal"
                        className="medalIcons"
                      />
                    </div>

                    <Accordion
                      className={`teamLayout teamWinner${index + 1}`}
                      expanded={expanded === family.id}
                      onChange={handleChange(family.id)}
                    >
                      <AccordionSummaryContainer
                        runner={family}
                        challengeParameter={challengeParameter}
                        radio="showFamilyGroup"
                        index={index}
                      />
                      <AccordionDetails>
                        {familyListData?.length > 0 && (
                          <BoardList
                            challengeParameter={ageWiseDataChallengeParameter}
                            radioValue={radioValue}
                            FamilyGroupData={familyListData}
                            teamLeaderId={family?.id}
                          />
                        )}
                      </AccordionDetails>
                    </Accordion>
                  </div>
                ))
              : null}

        {/* Team list (non-winners) */}
        <div className={classes.teamListContainer}>
          {radioValue === "team" &&
            teamData?.map((team) => (
              <Accordion
                key={team.id}
                expanded={expanded === team.id}
                onChange={handleChange(team.id)}
                style={{
                  marginLeft:
                    ApplicationUtil.hideMedal_Rank(challengeType?.id) && 0,
                  marginTop:
                    ApplicationUtil.hideMedal_Rank(challengeType?.id) && "30px",
                  width:
                    ApplicationUtil.hideMedal_Rank(challengeType?.id) && "100%",
                }}
                className={`teamList ${
                  team?.teamDistance > 0 || team?.teamTotalSteps > 0
                    ? ""
                    : "accordion"
                }`}
              >
                <AccordionSummaryContainer
                  team={team}
                  challengeParameter={challengeParameter}
                  radio="team"
                />
                <AccordionDetails>
                  {teamListData?.length > 0 && (
                    <BoardList
                      challengeParameter={challengeParameter}
                      distance={challengeParameter === "DISTANCE"}
                      time={challengeParameter === "DISTANCE"}
                      sort
                      data={editTeamMember(teamListData, challengeParameter)}
                      teamLeaderId={isExpandedTeam?.teamLeaderId}
                      style={{ width: "100%" }}
                    />
                  )}
                </AccordionDetails>
              </Accordion>
            ))}
        </div>

        {/* Runner group list (non-winners) */}
        <div className={classes.teamListContainer}>
          {radioValue === "runnerGroup" &&
            runnersData?.map((runner) => (
              <Accordion
                key={runner.runnerGroupId}
                expanded={expanded === runner?.runnerGroupId}
                onChange={handleChange(runner?.runnerGroupId)}
                className={`teamList ${
                  runner?.runnerGroupDistance > 0 ||
                  runner?.runnerGroupTotalSteps > 0
                    ? ""
                    : "accordion"
                }`}
              >
                <AccordionSummaryContainer
                  runner={runner}
                  challengeParameter={challengeParameter}
                  radio="runnerGroup"
                />
                <AccordionDetails>
                  {runnerListData?.length > 0 && (
                    <BoardList
                      challengeParameter={challengeParameter}
                      distance={challengeParameter === "DISTANCE"}
                      time={challengeParameter === "DISTANCE"}
                      sort
                      data={editTeamMember(runnerListData, challengeParameter)}
                      teamLeaderId={runner?.runnerGroupId}
                    />
                  )}
                </AccordionDetails>
              </Accordion>
            ))}
        </div>

        {/* Family group support */}
        <div className={classes.teamListContainer}>
          {radioValue === "showFamilyGroup" &&
            familyDisplayData?.map((familyGroup, index) => (
              <Accordion
                key={familyGroup.id}
                expanded={expanded === familyGroup.id}
                onChange={handleChange(familyGroup.id)}
                className={`teamList accordion`}
              >
                <AccordionSummaryContainer
                  runner={familyGroup}
                  challengeParameter={challengeParameter}
                  radio="showFamilyGroup"
                  index={index + 3}
                />
                <AccordionDetails>
                  {familyListData?.length > 0 && (
                    <BoardList
                      challengeParameter={ageWiseDataChallengeParameter}
                      radioValue={radioValue}
                      FamilyGroupData={familyListData}
                      teamLeaderId={familyGroup?.id}
                    />
                  )}
                </AccordionDetails>
              </Accordion>
            ))}
        </div>

        {/* Age wise */}
        <div className={classes.teamListContainer}>
          {radioValue === Properties?.ageWiseGroupRadioValue &&
            ageWiseData?.map((ageGroupItem, i) => (
              <div
                className={classes.winnerTeamsContainer}
                key={ageGroupItem.id}
              >
                <Accordion
                  expanded={expanded === ageGroupItem?.id}
                  onChange={handleChange(ageGroupItem?.id)}
                  className={`teamList ${classes.teamLayout}`}
                  style={{ marginLeft: "0" }}
                >
                  <AccordionSummaryContainer
                    AgeItem={ageGroupItem}
                    ageIndex={i}
                    radio={radioValue}
                  />
                  <AccordionDetails>
                    {ageGroupItem?.participantsDto?.length > 0 && (
                      <BoardList
                        challengeParameter={ageWiseDataChallengeParameter}
                        radioValue={radioValue}
                        AgeWiseData={ageGroupItem?.participantsDto.slice(0, 10)}
                        teamLeaderId={ageGroupItem?.id}
                      />
                    )}
                  </AccordionDetails>
                </Accordion>
              </div>
            ))}
        </div>

        {/* No data */}
        {!hasAnyData && (
          <div
            style={{
              textAlign: "center",
              marginTop: "10px",
              fontWeight: 600,
              fontSize: "20px",
              color: "gray",
            }}
          >
            <Typography
              style={{ textAlign: "center", fontSize: "20px", color: "gray" }}
            >
              {props.radioValue === "showFamilyGroup" && !value
                ? "Family group not found."
                : props.radioValue === "showFamilyGroup" && value
                  ? "Name not found."
                  : value
                    ? "Team not found. Please search for another team name."
                    : "Teams not found."}
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
}

export default compose(
  withStyles(styles, { withTheme: true }),
  withRouter,
)(TeamBoard);
